module.exports = __webpack_public_path__ + "app/principal/invoice-param-3C_wokWe.html";